/* eslint max-len: 0 */
export const messages = {
  page: {
    title: {
      id: 'kioskQuestionnaires.Page.Title',
      defaultMessage: '-def-Kiosk Questionnaires',
    },
    titleDescription: {
      id: 'kioskQuestionnaires.Page.TitleDescription',
      defaultMessage: '-def-To start a Questionnaire for a patient click <strong>Start</strong>. Only patients with questionnaires due on the selected date in the selected facility will appear in the list.',
    },
    noPatientsWithQuestionnaires: {
      id: 'kioskQuestionnaires.Page.NoItemsToDisplay',
      defaultMessage: '-def-No items to display',
    },
    featureInactive: {
      id: 'kioskQuestionnaires.Page.FeatureInactive',
      defaultMessage: '-def-Kiosk feature has been disabled.  Enable the kiosk feature and try again.',
    },
    startButtonText: {
      id: 'kioskQuestionnaires.Page.StartButtonText',
      defaultMessage: '-def-Start',
    },
    labels: {
      facility: {
        id: 'kioskQuestionnaires.Page.Labels.Facility',
        defaultMessage: '-def-Facility:',
      },
      all: {
        id: 'kioskQuestionnaires.Page.Labels.AllFacilities',
        defaultMessage: '-def-All',
      },
      dueDate: {
        id: 'kioskQuestionnaires.Page.Labels.DueDate',
        defaultMessage: '-def-Due Date:',
      },
      inactiveQuestionnaire: {
        id: 'kioskQuestionnaires.Page.Labels.InactiveQuestionnaire',
        defaultMessage: '-def-Questionnaires not yet active',
      },
    },
  },
  modal: {
    title: {
      id: 'kioskQuestionnaires.Modal.Title',
      defaultMessage: '-def-Start Questionnaire?',
    },
    labels: {
      patientName: {
        id: 'kioskQuestionnaires.Modal.Labels.PatientName',
        defaultMessage: '-def-Patient Name:',
      },
      dateOfBirth: {
        id: 'kioskQuestionnaires.Modal.Labels.DateOfBirth',
        defaultMessage: '-def-Date of Birth:',
      },
      mrn: {
        id: 'kioskQuestionnaires.Modal.Labels.Mrn',
        defaultMessage: '-def-MRN:',
      },
      facilityShortName: {
        id: 'kioskQuestionnaires.Modal.Labels.FacilityShortName',
        defaultMessage: '-def-Facility:',
      },
      assignedQuestionnaires: {
        id: 'kioskQuestionnaires.Modal.Labels.AssignedQuestionnaires',
        defaultMessage: '-def-Assigned Questionnaire(s):',
      },
      buttons: {
        yesButton: {
          id: 'kioskQuestionnaires.Modal.Buttons.YesButtonText',
          defaultMessage: '-def-Yes',
        },
        cancelButton: {
          id: 'kioskQuestionnaires.Modal.Buttons.CancelButtonText',
          defaultMessage: '-def-Cancel',
        },
      },
    },
  },
  columnHeader: {
    patientName: {
      id: 'kioskQuestionnaires.ColumnHeader.PatientName',
      defaultMessage: '-def-PatientName',
    },
    dateOfBirth: {
      id: 'kioskQuestionnaires.ColumnHeader.DateOfBirth',
      defaultMessage: '-def-Date of Birth',
    },
    mrn: {
      id: 'kioskQuestionnaires.ColumnHeader.Mrn',
      defaultMessage: '-def-MRN',
    },
    facilityShortName: {
      id: 'kioskQuestionnaires.ColumnHeader.FacilityShortName',
      defaultMessage: '-def-Facility',
    },
    numberQuestionnaires: {
      id: 'kioskQuestionnaires.ColumnHeader.NumberQuestionnaires',
      defaultMessage: '-def-# Questionnaires',
    },
  },
  sortedDisplayNameFormat: {
    id: 'sortedDisplayNameFormat',
    defaultMessage: '-def-{1}, {0}',
  },
  displayNameFormat: {
    id: 'displayNameFormat',
    defaultMessage: '-def-{0} {1}',
  },
};